// Core
import React, { lazy, Suspense } from "react";
import { render } from "react-dom";
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import moment from 'moment';

// Instruments
import store from 'init/store';
import history from 'init/history';
import Routes from 'routes';

// Containers
const Widgets = lazy(() => import(/* webpackChunkName: "widgets" */'containers/widgets'));

moment.locale('ru');

const rootRef = document.getElementById("donkey-root");

render((
    <Provider store = { store }>
        <ConnectedRouter history = { history }>
            <Suspense fallback = { <div /> } >
                <Routes />
                <Widgets />
            </Suspense>
        </ConnectedRouter>
    </Provider>
), rootRef);
